/**
 * Inidicator for a valid or invalid state
 * @type {{VALID: number; FAILED: number}}
 */
export const ValidationState = {
  VALID: 1,
  FAILED: 2,
};



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/widgets/shared/states.ts